define('components/course/collections/sections',[
    'components/course/collections/base',
    'components/course/models/section',
    'components/course/radio-channel'
], function (BaseCollection, Section, channel) {
    "use strict";

    var ModuleEvent = channel.Event.Module,
        SectionEvent = channel.Event.Section,
        SlideEvent = channel.Event.Slide;

    return BaseCollection.extend({
        "model": Section,

        "initialize": function () {
            this.initRadioComm();
            this.on('change', this.onChange, this);
            this.onChange();
        },

        "initRadioComm": function () {
            channel.comply(SectionEvent.COMPLETE, this.completeSection, this)
                .comply(SectionEvent.GOTO, this.gotoSection, this)
                .comply(SectionEvent.NEXT, this.nextSection, this)
                .comply(SectionEvent.PREV, this.prevSection, this)
                .comply(SlideEvent.COMPLETE, this.completeSlide, this)
                .comply(SlideEvent.NEXT, this.nextSlide, this)
                .comply(SlideEvent.PREV, this.prevSlide, this);

            channel.reply(SectionEvent.ACTIVE, this.getActiveSection, this)
                .reply(SectionEvent.FROM_SLIDE, this.getSectionFromSlide, this)
                .reply(SlideEvent.ACTIVE, this.getActiveSlide, this)
                .reply(SlideEvent.FROM_GUID, this.getSlideFromGuid, this);

            return this;
        },

        "getActiveSection": function () {
            return this.findWhere({"isActive": true}) || null;
        },

        "getActiveSectionIndex": function () {
            return this.indexOf(this.getActiveSection());
        },

        "getActiveSlide": function () {
            return this.getActiveSection().getActiveSlide();
        },

        "getSlideFromGuid": function (guid) {
            var section = null,
                slides = null,
                slide = null,
                i = 0;

            if (!guid) {
                return slide;
            }

            guid = guid.toLowerCase();

            for (; i < this.length && !slide; i++) {
                section = this.at(i);
                slides = section.get('slides');

                slide = slides.findWhere({
                    "guid": guid
                }) || null;
            }

            return slide;
        },

        "isComplete": function () {
            var completedSections = this.where({
                    "isComplete": true
                });

            return completedSections.length === this.length;
        },

        "onChange": function () {
            var isComplete = this.isComplete();
            channel.command(ModuleEvent.COMPLETE, isComplete);
        },

        "setActiveSection": function (section) {
            var activeSection,
                oldIndex,
                newIndex,
                navigationDirection;

            newIndex = this.indexOf(section);

            if (newIndex === -1) {
                return this;
            }

            activeSection = this.getActiveSection();
            oldIndex = this.getActiveSectionIndex();

            if (activeSection === section) {
                return this;
            }

            navigationDirection = newIndex < oldIndex ? -1 : 1;

            channel.command(ModuleEvent.NAV_DIRECTION, navigationDirection);

            activeSection.getActiveSlide().set('isActive', false);
            activeSection.set('isActive', false);
            section.set('isActive', true);

            channel.trigger(SectionEvent.CHANGE, this, section);

            if (navigationDirection === 1) {
                section.setActiveSlide(0);
            } else {
                section.setActiveSlide(section.get('slides').length - 1);
            }

            return this;
        },

        "completeSlide": function (isComplete) {
            var activeSection = this.getActiveSection(),
                activeSlide = activeSection && activeSection.getActiveSlide();

            isComplete = isComplete === void 0 || !!isComplete;

            activeSlide.set('isComplete', isComplete);
        },

        "nextSlide": function () {
            this.getActiveSection().nextSlide();
            return this;
        },

        "prevSlide": function () {
            this.getActiveSection().prevSlide();
            return this;
        },

        "completeSection": function (isComplete) {
            var activeSection = this.getActiveSection();

            if (activeSection) {
                this.getActiveSection().set('isComplete', isComplete);
            }
        },

        "gotoSection": function (sectionGuid) {
            var section;

            section = this.findWhere({
                "guid": sectionGuid
            });

            if (section) {
                this.setActiveSection(section);
            }

            return this;
        },

        "nextSection": function () {
            var activeSectionIndex = this.getActiveSectionIndex();

            activeSectionIndex++;

            if (activeSectionIndex === this.length) {
                // TODO: at this point we need to let the module
                // know that all sections have ended
                return this;
            }

            this.setActiveSection(this.at(activeSectionIndex));

            return this;
        },

        "prevSection": function () {
            var activeSectionIndex = this.getActiveSectionIndex();

            activeSectionIndex--;

            if (activeSectionIndex < 0) {
                // TODO: at this point we need to let the module
                // know that all sections have ended
                return this;
            }

            this.setActiveSection(this.at(activeSectionIndex));

            return this;
        },

        "getSectionFromSlide": function (slide) {
            var result = null;
            this.each(function (section) {
                var slides;

                if (result) {
                    return;
                }

                slides = section.get('slides');

                if (slides.indexOf(slide) > -1) {
                    result = section;
                }
            });

            return result;
        }
    });
});

